module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && _vm.navs.length),
      expression: "show && navs.length"
    }],
    staticClass: "app-bottom-navigator-wrapper"
  }, [_vm._t("navs", [_c('v-bottom-nav', {
    staticClass: "transparent",
    attrs: {
      "value": _vm.show,
      "active": _vm.activeNav,
      "absolute": ""
    }
  }, _vm._l((_vm.navs), function(nav) {
    return _c('v-btn', {
      key: nav.name,
      attrs: {
        "value": nav.name,
        "flat": "",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleNavClick(nav.route, nav.name)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(nav.text))]), _vm._v(" "), (nav.svg) ? _c('icon', {
      staticClass: "app-header-icon",
      attrs: {
        "name": nav.svg
      }
    }) : (nav.icon) ? _c('v-icon', {
      staticClass: "app-header-icon"
    }, [_vm._v(_vm._s(nav.icon))]) : _vm._e()], 1)
  }))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e27aed","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/components/AppBottomNavigator.vue
// module id = 582
// module chunks = 6